<tt-field-group :asFieldset="!isSingleCheckbox"
                :describedbyId="describedbyId"
                :errorText="errorText"
                :hintText="hintText"
                :label="label"
                :labelId="labelId"
                :required="isSingleCheckbox ? false : required">
  <div class="tt-o-check-group" :class="groupClasses">
    <div v-for="field in decoratedFields" :class="itemClass">
      <input v-if="isCheckboxGroup" v-model="values" :class="inputClass" type="checkbox" :id="field.id" :name="groupName" :aria-describedby="describedbyIdValue" :value="field.value" :disabled="field.disabled">
      <input v-if="isSingleCheckbox" v-model="value" :class="inputClass" type="checkbox" :id="field.id" :name="groupName" :aria-describedby="describedbyIdValue" :value="field.value" :disabled="field.disabled">
      <input v-if="isRadio" v-model="value" :class="inputClass" type="radio" :id="field.id" :name="groupName" :aria-describedby="describedbyIdValue" :value="field.value" :disabled="field.disabled">
      <label v-if="isIconType || isImageType" :class="itemLabelClass" :for="field.id">
        <tt-icon v-if="isIconType" :name="field.iconName" :title="field.label" class="tt-o-radio-icon__icon"></tt-icon>
        <img v-else="isImageType" :src="field.imagePath" class="tt-o-radio-image__image">
      </label>
      <label v-else :class="itemLabelClass" :for="field.id" v-html="field.label"></label>
    </div>
  </div>
</tt-field-group>
